export enum NotificationCategoryEnumTypes {
    GENERIC = 'GENERIC',
    USER_CREATION = 'USER_CREATION',
    CALENDAR_EVENT_CREATION = 'CALENDAR_EVENT_CREATION',
    CALENDAR_EVENT_UPDATE = 'CALENDAR_EVENT_UPDATE',
}
